<template>
	<b-row>
		<b-col lg="3" md="4" sm="6" xl="2">
			<b-form-group
					:invalid-feedback="
                      invalidFeedbackLegalFileNumber
                        ? $t(`validation.${invalidFeedbackLegalFileNumber}`, {
                            field: $t('user.legalFileNumber'),
                          })
                        : ''
                    "
					:label="$t('user.legalFileNumber')"
          :state="v.legalFileNumber.$dirty ? ((!v.legalFileNumber.$invalid === false) ? false : null) : null"
					:class="{ 'required-group': !v.legalFileNumber.required }"
					label-for="user-legalFileNumber"
			>
				<b-form-input
						id="user-legalFileNumber"
						v-model="legalFileNumber"
            :state="v.legalFileNumber.$dirty ? ((!v.legalFileNumber.$invalid === false) ? false : null) : null"
        />
			</b-form-group>
		</b-col>
    <b-col xl="2" lg="3" md="4" sm="6">
      <b-form-group
          label-for="user-startDateAtWork"
          :label="$t('user.startDateAtWork')"

      >
        <my-ab-date-picker
            :mode="'single'"
            :type="'date'"
            :locale="'fa,en'"
            click-on="all"
            clearable
            :show="false"
            :auto-submit="true"
            :column="1"
            v-model="startDateAtWork"
        >
        </my-ab-date-picker>
      </b-form-group>
    </b-col>
    <b-col xl="2" lg="3" md="4" sm="6">
      <b-form-group
          label-for="user-endDateAtWork"
          :label="$t('user.endDateAtWork')"

      >
        <my-ab-date-picker
            :mode="'single'"
            :type="'date'"
            :locale="'fa,en'"
            click-on="all"
            clearable
            :show="false"
            :auto-submit="true"
            :column="1"
            v-model="endDateAtWork"
        >
        </my-ab-date-picker>
      </b-form-group>
    </b-col>
	</b-row>
</template>

<script>
import {
	BRow,
	BCol,
	BFormGroup,
	BFormInput,
	BFormSelect,
	BFormInvalidFeedback,
} from "bootstrap-vue";
import {mapGetters} from 'vuex';
import MyAbDatePicker from "@/components/wrapper/datePicker/MyAbDatePicker";
export default {
	components:{
		MyAbDatePicker,
		BRow,
		BCol,
		BFormGroup,
		BFormInput,
		BFormSelect,
		BFormInvalidFeedback},
	props:['v'],
	computed:{
		legalFileNumber: {
			set(legalFileNumber) {
				this.$store.commit("user/SET_LEGAL_FILE_NUMBER", legalFileNumber);
			},
			get() {
				return this.$store.getters["user/legalFileNumber"];
			},
		},
    startDateAtWork: {
      set(startDateAtWork) {
        this.$store.commit("user/SET_START_DATE_AT_WORK", startDateAtWork);
      },
      get() {
        return this.$store.getters["user/startDateAtWork"];
      },
    },
    endDateAtWork: {
      set(endDateAtWork) {
        this.$store.commit("user/SET_END_DATE_AT_WORK", endDateAtWork);
      },
      get() {
        return this.$store.getters["user/endDateAtWork"];
      },
    },
		invalidFeedbackLegalFileNumber: {
			set(error) {
			},
			get() {
				var error = "";
				if (!this.v.legalFileNumber.$dirty) return error;
				if (!this.v.legalFileNumber.required) error = "required";
				return error;
			},
		},
	}
}
</script>